var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('div',{staticClass:"pa-6"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Release Notes")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }